<template>
  <el-container>
    <el-main>   
  
  <ApolloQuery  :query="require('./customerEdit.gql')" :variables="{id:id}" fetchPolicy = "no-cache">
    
  <template slot-scope="{ result: { data, loading } }">
      <el-row type="flex" justify="space-start" >
    
    <div v-if="loading" class="loading apollo">Loading...</div>
    
    

        <el-col :span="24" v-else-if="data" class="result apollo">
          <el-card
            shadow="always"
            :body-style="{ background: '#f5f5f5' }"
            v-if="data"
          >       

            <div
              slot="header"
        
            >
              <h2 class="card-title">
                <router-link :to="'/customer/edit/'+data.Customer_by_pk.id">{{data.Customer_by_pk.firstname}} {{data.Customer_by_pk.lastname}}</router-link>
                <small class="pull-right">Customer ID: {{data.Customer_by_pk.id}}</small>
              </h2>
              <i class="ti-email"></i>
              {{data.Customer_by_pk.email}}
             
           
            </div>
     
          </el-card>
          <el-card
            shadow="always"
            :body-style="{ background: '#f5f5f5' }"
            v-else
          >
            <h2>No customer found with that id</h2>
          </el-card>
        </el-col>
    
 
      </el-row>

      <el-row v-if="data" type="flex" justify="space-start" :gutter="20">
        <el-col :span="12">
          <edit-profile-form :customer="data.Customer_by_pk" :countries="countries"></edit-profile-form>
        </el-col>
        <el-col :span="12"><customer-order-info v-bind:customer="data.Customer_by_pk"></customer-order-info>
  
          <div class="card-footer"></div>
        </el-col>
      </el-row>
       </template>
        </ApolloQuery>
    </el-main>
  </el-container>
</template>
<script>
import gql from "graphql-tag";

import EditProfileForm from "./CustomerProfile/EditProfileForm.vue";
import CustomerOrderInfo from "./CustomerProfile/CustomerOrderInfo.vue";
import Actions from './CustomerProfile/Actions.vue'
import CreateCert from './CustomerProfile/CreateCert.vue'
import Lmsprogress from './CustomerProfile/LMSProgress.vue'
import json from "../../data/allCountries.json";
//import MetaData from './CustomerProfile/MetaData.vue'
//import { CURRENT_CUSTOMER } from '../../store/actions/customer'
export default {
  components: {
    EditProfileForm,
    CustomerOrderInfo,
       Actions,
       CreateCert,
       Lmsprogress
    //   MetaData
  },

  data() {
    return {
     id:'',
      customer: { shippingAddress: { line1: "", line2: "", phone: "" } },
      countries: json,
      session: ""
    };
  },
  methods: {
    loginAsCustomer() {
      const loginAs = api.loginAsCustomer({ username: this.customer.email }); //axios.get(this.usersUrl);
      Promise.resolve(loginAs).then(result => {
        console.log(result)
        this.session = result.data.jwt_token;
        this.userid = result.data.user_id;
        window.open(
          "https://www.tefl.org/my-account/?session=" + this.session + "&userid=" + this.userid
        );
      });
    },
    getCustomer(id) {
      const q = gql`
      query {
        Customer_by_pk (
          id:${id}
        ) {
          id
          title
          email
          username
          firstname
          middlenames
          lastname
          dateOfBirth
          shippingAddress{    
              id
              line1
              line2
              phone
              town
              postcode
              region
              country
          }
          notes(order_by:{dateCreated:desc}){
            id 
            detail
            createdBy
            dateCreated
          }
        orders(order_by: {dateCreated: desc}){
            id
            status
            boughtProductTotal
            boughtProductTotalDiscounted
            boughtProducts{
              product{
                id
                type
                name
              }
            }
          } 
        }
      }`;
      this.$apollo.query({ query: q }).then(
        resp => {
          console.log("resp", resp);
          this.customer = resp.data.Customer_by_pk;
        },
        error => {
          console.error(
            "Got nothing from server. Prompt user to check internet connection and try again " + error
          );
        }
      );
    },

    deleteCustomer() {
      api.deleteCustomer({ id: this.customer.id }).then(response => {
        //this.notes = response.data.data;
        this.$notify({
          title: "Deleted",
          message: "Customer Deleted",
          type: "success"
        });
        //redirect to create customer
        this.$router.push({ path: "/customers" });
      });
    },

    getCountries() {
      const registerCountries = api.getCountries(); //axios.get(this.usersUrl);
      Promise.resolve(registerCountries).then(result => {
        this.countries = result.data.data;
      });
    }
  },
  watch: {
    "$route.params.id": function(id) {
      this.id=id
     // this.getCustomer(id);
    }
  },
  mounted() {
    this.id=this.$route.params.id
    // this.getCountries();
    //this.getCustomer(this.$route.params.id);
  }
};
</script>
<style>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Customers/CustomerDetail.vue